/**
 * Everything that identifies one deployment of Fadila, read from the
 * environment at build time. Nothing in the source names a registration,
 * a host or a project: a fork fills in `.env.local` from `.env.example`
 * (docs/DEPLOYMENT.md says what each value is and where to create it), and
 * `.env.development.local` overrides for the dev server where a provider
 * needs a second registration for localhost.
 *
 * Create React App inlines `import.meta.env.VITE_*` at build time, so every
 * read has to be a literal property access. An unset value is the empty
 * string; each provider decides what that means for it - Spotify and
 * SoundCloud switch themselves off, the rest fail at sign-in.
 */

/**
 * A deployment with no Google client id cannot sign in to anything that
 * matters, and the only symptom is a sign-in that quietly fails. Say so at
 * startup instead. (This is how a rename of the variables once shipped a
 * production build with no ids in it at all.)
 */
if (!import.meta.env.VITE_GOOGLE_CLIENT_ID) {
  console.warn(
    'VITE_GOOGLE_CLIENT_ID is not set: Google sign-in will fail. ' +
      'Copy .env.example to .env.local and fill in the registrations (docs/DEPLOYMENT.md).',
  );
}
export const googleApiKey = import.meta.env.VITE_GOOGLE_API_KEY || '';
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

export const microsoftClientId = import.meta.env.VITE_MICROSOFT_CLIENT_ID || '';

export const dropboxAppKey = import.meta.env.VITE_DROPBOX_APP_KEY || '';

export const spotifyClientId = import.meta.env.VITE_SPOTIFY_CLIENT_ID || '';

export const soundCloudClientId = import.meta.env.VITE_SOUNDCLOUD_CLIENT_ID || '';

/** Where fadila-backend is deployed, including the `/api` prefix. */
export const backendHost = (import.meta.env.VITE_BACKEND_HOST || '').replace(/\/$/, '');

/** Unset means no error reporting. */
export const sentryDsn = import.meta.env.VITE_SENTRY_DSN || '';
